module.exports = __webpack_public_path__ + "static/media/NB-MX5.4a931428.jpg";